import React from 'react';
import styled from 'styled-components';
import { PrivacyTrustData } from '../types/siteDataTypes';
import { Section, Container, SectionHeading } from '../styles/layout';

interface PrivacyTrustProps {
  data?: PrivacyTrustData;
}

const SectionTitle = styled(SectionHeading)`
  margin-bottom: 30px;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
`;

const ListItem = styled.li`
  color: #4a5a6b;
  line-height: 1.6;
  background: linear-gradient(145deg, rgba(239, 244, 249, 0.6), rgba(223, 231, 240, 0.6));
  border: 1px solid #cfd9e4;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 18px 36px rgba(34, 50, 70, 0.12);
`;

const Closing = styled.div`
  text-align: center;
  color: #4a5a6b;
  line-height: 1.65;
  background: linear-gradient(145deg, rgba(239, 244, 249, 0.6), rgba(223, 231, 240, 0.6));
  border: 1px solid #cfd9e4;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 20px 40px rgba(34, 50, 70, 0.12);
`;

const PrivacyTrust: React.FC<PrivacyTrustProps> = ({ data }) => {
  return (
    <Section>
      <Container>
        <SectionTitle>
          <h2>{data?.heading || 'Privacy & Trust'}</h2>
          <p>{data?.subheading || ''}</p>
        </SectionTitle>
        <List>
          {data?.bullets?.map((item, idx) => (
            <ListItem key={`privacy-${idx}`}>{item}</ListItem>
          ))}
        </List>
        {data?.closing && <Closing>{data.closing}</Closing>}
      </Container>
    </Section>
  );
};

export default PrivacyTrust;
